import { AccountsTotalsContext } from 'core/cuenta/contexts/AccountsTotalsContext';
import { Business } from 'core/empresa/models/Business';
import { useContext } from 'react';
import { Card } from 'react-bootstrap';
import { formatDateParams } from 'shared/utils';

export const BusinessDetails = (props: { business: Business }) => {
  const { searchParams } = useContext(AccountsTotalsContext);

  return (
    <Card>
      <Card.Header className="text-center">{props.business.denominacion}</Card.Header>
      <Card.Body>
        <p className="fw-semibold text-center">
          Total del organismo - Apertura por cuenta
        </p>
        <p className="fw-semibold text-center">{formatDateParams(searchParams)}</p>
      </Card.Body>
    </Card>
  );
};
